import { __assign } from "tslib";
import { getCurrentScale as getScaleFunc, getScreenStyles } from './layout';
export function getRowsEnabled(state) {
    return getRowSettings(state).enabled;
}
export function getColumnsEnabled(state) {
    return getColumnSettings(state).enabled;
}
export function getIsRowOverlayOn(state) {
    return state.layoutOverlay.isRowOverlayOn;
}
export function getIsColumnOverlayOn(state) {
    return state.layoutOverlay.isColumnOverlayOn;
}
export function getRowConfig(state) {
    var _a = getRowSettings(state), gutterHeight = _a.gutterHeight, heightAsGutterMultiple = _a.heightAsGutterMultiple;
    var pixelRatio = getPixelRatio(state);
    var scaleFunc = getScaleFunc(state);
    var imageHeight = getScreenStyles(state, true).imageHeight;
    var scaledGutterHeight = scaleFunc(gutterHeight, true) * pixelRatio;
    var rowCount = imageHeight / (scaledGutterHeight * (1 + heightAsGutterMultiple));
    return __assign({ count: rowCount, gutterHeight: scaledGutterHeight, heightAsGutterMultiple: heightAsGutterMultiple }, getVisuals(state));
}
export function getColumnConfig(state) {
    var _a = getColumnSettings(state), offset = _a.offset, count = _a.count, isGutterOnOutside = _a.isGutterOnOutside, gutterWidth = _a.gutterWidth, columnWidth = _a.columnWidth, totalWidth = _a.totalWidth;
    var scaleFunc = getScaleFunc(state);
    var pixelRatio = getPixelRatio(state);
    return __assign({ count: count, isGutterOnOutside: isGutterOnOutside, offset: scaleFunc(offset, true) * pixelRatio, gutterWidth: scaleFunc(gutterWidth, true) * pixelRatio, columnWidth: scaleFunc(columnWidth, true) * pixelRatio, totalWidth: scaleFunc(totalWidth, true) * pixelRatio }, getVisuals(state));
}
function getVisuals(state) {
    var _a = getVisualSettings(state), gridType = _a.gridType, lightColor = _a.lightColor, darkColor = _a.darkColor;
    var fillColor;
    var strokeColor;
    if (gridType === 'fillGrid') {
        fillColor = lightColor.rgbaValues;
    }
    else {
        strokeColor = darkColor.rgbaValues;
    }
    return { fillColor: fillColor, strokeColor: strokeColor };
}
function getPixelRatio(state) {
    return getArtboard(state).pixelRatio;
}
function getArtboard(state) {
    return state.handoff.canvas.artboard;
}
export function getRowSettings(state) {
    var rows = getArtboard(state).layout.rows;
    if (!rows) {
        return { enabled: false };
    }
    return __assign(__assign({}, rows), { heightAsGutterMultiple: rows.rowHeight });
}
export function getColumnSettings(state) {
    var columns = getArtboard(state).layout.columns;
    if (!columns) {
        return { enabled: false };
    }
    columns = __assign(__assign({}, columns), { count: columns.numberOfColumns, isGutterOnOutside: columns.gutterOnOutside });
    return columns;
}
function getVisualSettings(state) {
    return getArtboard(state).layout.visuals;
}
